import { createApi } from '@reduxjs/toolkit/query/react'
import { query } from 'api'
import type { Project, ProjectInfo, ProjectList } from 'types/Project'
import type { SalesNetworkResponse } from 'types/SalesNetworks'
// import type { SatisfactionForm } from './satisfactionSlice';

export interface GetListOptions {
  filterData?: any
  Sorts?:
  | {
    Member: string
    SortDirection: number
  }[]
  | null
}

const rtkApi = createApi({
  keepUnusedDataFor: 0,
  reducerPath: 'api',
  baseQuery: query(),
  tagTypes: ['Locations', 'Villes', 'UserInfo', 'ClientInfo', 'ProjectsList'],
  endpoints: (builder) => ({
    // getSalesNetworks: builder.query<SalesNetworksResponse, void>({
    //   query: () => ({ url: "Application/SalesNetworks", method: "GET" }),
    // }),
    getInfos: builder.query<SalesNetworkResponse, string>({
      query: (env) => ({
        url: `infos/${env}`,
        method: 'GET',
      }),
    }),
    getTranslations: builder.query<any, string>({
      query: (lang) => ({
        url: `formattedLocale/${lang}`,
        method: 'GET',
      }),
    }),
    getTutorials: builder.query<TutorialsResponse, { environnement_id: number | string; lang: string }>({
      query: ({ environnement_id, lang }) => ({
        url: `tutorials/env=${environnement_id}&lang=${lang}`,
        method: 'GET',
        params: {},
      }),
    }),
    //TODO: network code
    getFAQ: builder.query<FAQResponse, null>({
      query: () => ({
        url: 'faq',
        method: 'GET',
      }),
    }),
    getVersions: builder.query<VersionsResponse, null>({
      query: () => ({
        url: 'versions',
        method: 'GET',
      }),
    }),
    getMaintenance: builder.query({
      query: () => ({
        url: `maintenance/get`,
        method: 'GET',
      }),
    }),

    getUserInfo: builder.query<UserInfo, void>({
      query: () => ({
        url: `userinfos`,
        method: 'GET',
      }),
      providesTags: ['UserInfo'],
    }),

    updateUserInfo: builder.mutation<void, any>({
      query: (userInfo) => {
        // if (systemUser.images == null)
        //   systemUser = { ...systemUser, images: [] };
        return {
          url: `userinfos`,
          method: 'PATCH',
          data: { data: userInfo },
          headers: {
            'Content-Type': 'application/json',
          },
        }
      },
      invalidatesTags: ['UserInfo'],
    }),

    updateSatisfaction: builder.mutation<void, any>({
      query: (formData) => {
        return {
          url: `satisfaction/1`,
          method: 'POST',
          data: formData,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      },
    }),

    getClients: builder.query<
      ClientList,
      {
        pageNumber: number | string
        pageSize: number | string
        searchInput: string
      }
    >({
      query: ({ pageNumber, pageSize, searchInput }) => ({
        url: `client?pageNumber=${pageNumber}&pageSize=${pageSize}&searchInput=${searchInput}`,
        method: 'GET',
      }),
      providesTags: ['ClientInfo'],
    }),
    createClient: builder.mutation<Client, { data: ClientInfo }>({
      query: (payload) => {
        // debugger;

        return {
          url: `client`,
          method: 'POST',
          data: payload,
          // data: { data: clientData },
          headers: {
            'Content-Type': 'application/json',
          },
        }
      },
      invalidatesTags: ['ClientInfo'],
    }),

    updateClient: builder.mutation<void, { id?: number; data: ClientInfo }>({
      query: (payload) => {
        // debugger;

        return {
          url: `client/${payload.id}`,
          method: 'PATCH',
          data: payload,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      },
      invalidatesTags: ['ClientInfo'], // Adjust tags as needed
    }),

    deleteClient: builder.mutation<void, number>({
      query: (id) => {
        return {
          url: `client/${id}`,
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      },
      invalidatesTags: ['ClientInfo'], // Adjust tags as needed
    }),
    // getLocations: builder.query<GetLocationsResponse, void>({
    //   query: () => ({
    //     url: `Moteur/GetLocations`,
    //     method: "GET",
    //   }),
    //   transformResponse: (res: GetLocationsResponse) => {
    //     return res.map((i) => ({ text: i.text, value: i.text }));
    //   },
    //   providesTags: () => [{ type: "Locations" }],
    // }),
    // getLocationInfo: builder.query<
    //   GetLocationInfoResponse,
    //   { code: string; altitude?: number; bord_de_mer_montagne?: boolean }
    // >({
    //   query: ({ code, altitude, bord_de_mer_montagne }) => ({
    //     url: `Moteur/GetLocationInfo`,
    //     method: "GET",
    //     params: { code_ville: code, altitude, bord_de_mer_montagne },
    //   }),
    // }),
    // getVilles: builder.query<GetVillesResponse, { networkCode: string }>({
    //   query: ({ networkCode }) => ({
    //     url: `Moteur/GetVilles`,
    //     method: "GET",
    //     params: { code_commercial: networkCode },
    //   }),
    //   transformResponse: (res: GetVillesResponse) => {
    //     return res.map((i) => ({ ...i, text: i.text, value: i.text }));
    //   },
    //   providesTags: () => [{ type: "Villes" }],
    // }),
    // getSolutionElectric: builder.query<GetSolutionResponse, GetSolutionRequest>(
    //   {
    //     query: (data) => ({
    //       url: `Moteur/SolutionElectric`,
    //       method: "POST",
    //       data,
    //       isJson: true,
    //     }),
    //   }
    // ),
    // getSolutionHybride: builder.query<GetSolutionResponse, GetSolutionRequest>({
    //   query: (data) => ({
    //     url: `Moteur/SolutionHybride`,
    //     method: "POST",
    //     data,
    //     isJson: true,
    //   }),
    // }),
    // getEtude: builder.query<GetEtudeResponse, { id: number; code?: string }>({
    //   query: ({ id, code }) => ({
    //     url: `Etude/GetData`,
    //     method: "GET",
    //     params: { id: id, code: code },
    //     //isJson: true,
    //   }),
    // }),
    getProjectsList: builder.query<
      ProjectList,
      { code?: string | undefined; pageSize?: number; pageNumber?: number; searchInput?: string; stepIndexes?: number[] }
    >({
      query: ({ code, pageSize, pageNumber, searchInput, stepIndexes }) => ({
        url: `projects/${code}`,
        method: 'GET',
        params: { pageSize: pageSize, pageNumber: pageNumber, searchInput: searchInput, stepIndexes },
        //isJson: true,
      }),
      providesTags: ['ProjectsList'],
    }),
    updateDublicateProject: builder.mutation<void, { project?: Project }>({
      query: ({ project }) => ({
        url: `duplicateProject/${project?.id}`,
        method: 'GET',
        //isJson: true,
      }),
      invalidatesTags: ['ProjectsList'],
    }),
    loadProject: builder.query<ProjectInfo, { id: string; uid?: string }>({
      query: ({ id, uid }) => ({
        url: `project/${id}` + (uid ? `/${uid}` : ''),
        method: 'GET',
        //isJson: true,
      }),
    }),
    createProject: builder.mutation<ProjectInfo, ProjectInfo>({
      query: (project) => {
        // debugger;

        return {
          url: `project`,
          method: 'POST',
          data: project,
          headers: {
            'Content-Type': 'application/json',
          },
          isJson: true,
        }
      },
      invalidatesTags: ['ProjectsList'],
    }),

    updateProject: builder.mutation<void, ProjectInfo>({
      query: (project) => {
        // debugger;

        return {
          url: `project/${project.id}`,
          method: 'PATCH',
          data: project,
          headers: {
            'Content-Type': 'application/json',
          },
          isJson: true,
        }
      },
      invalidatesTags: ['ProjectsList'], // Adjust tags as needed
    }),
    deleteProject: builder.mutation<void, { project?: Project; includeVersions?: boolean }>({
      query: ({ project, includeVersions }) => {
        return {
          url: `project/${project?.id}` + (includeVersions ? '?includeVersions=true' : ''),
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      },
      invalidatesTags: ['ProjectsList'],
    }),
    getParamenters: builder.query<Parameter[], { env?: number }>({
      query: ({ env }) => ({
        url: `parameters/env=${env}`,
        method: 'GET',
      }),
    }),
    getDepartments: builder.query<ValueListItem[], { env?: string }>({
      query: ({ env }) => ({
        url: `departments/${env}`,
        method: 'GET',
        //isJson: true,
      }),
    }),
    getStations: builder.query<ValueListItem[], { env?: string; department?: string }>({
      query: ({ env, department }) => ({
        url: `stations/${env}/${department}`,
        method: 'GET',
        //isJson: true,
      }),
    }),
    getTbase: builder.query<number, { env?: string; department: string; altitude: number; seaside: boolean }>({
      query: ({ env, department, altitude, seaside }) => {
        return {
          url: `tbase/${env}/${department}/${altitude}/${seaside}`,
          method: 'GET',
        }
      },
    }),
    getVAT: builder.query<any[], { env?: string }>({
      query: ({ env }) => {
        return {
          url: `vatByEnv/${env}`,
          method: 'GET',
        }
      },
    }),

    getHeatingSystems: builder.query<any[], { env?: string }>({
      query: ({ env }) => ({
        url: `heatingsystem/${env}`,
        method: 'GET',
      }),
    }),

    getLoss: builder.mutation<any, { env: string; project: any }>({
      query: ({ env, project }) => {
        // debugger;
        return {
          url: `loss/${env}`,
          method: 'POST',
          data: { project },
          // data: { data: clientData },
          headers: {
            'Content-Type': 'application/json',
          },
          isJson: true,
        }
      },
      // invalidatesTags: ["ClientInfo"],
    }),
    getFlowTemperature: builder.mutation<any, { data: any }>({
      query: ({ data }) => {
        return {
          url: `flowTemperature`,
          method: 'POST',
          data: data,
          headers: {
            'Content-Type': 'application/json',
          },
          isJson: true,
        }
      },
    }),
    getResults: builder.query<any, { env?: string; project: any }>({
      query: ({ env, project }) => ({
        url: `results/${env}`,
        data: { project },
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        isJson: true,
      }),
    }),
    getAccessories: builder.query<any[], { env?: string; productCode: string }>({
      query: ({ env, productCode }) => ({
        url: `accessories/${env}/${productCode}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        isJson: true,
      }),
    }),
    getDocuments: builder.query<any[], { env?: string; productId: string }>({
      query: ({ env, productId }) => ({
        url: `documents/${env}/${productId}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        isJson: true,
      }),
    }),
    generateXlsx: builder.mutation<Blob, { data?: any }>({
      query: ({ data }) => {
        // debugger;
        return {
          url: `generateXlsx`, //UpdateFormDataJson
          method: 'POST',
          data: data,
          headers: {
            'Content-Type': 'application/json',
          },
          isJson: true,
          responseType: 'blob',
        }
      },
    }),
    generatePdf: builder.mutation<Blob, { data?: any }>({
      query: ({ data }) => {
        // debugger;
        return {
          url: `generatePdf`, //UpdateFormDataJson
          method: 'POST',
          data: data,
          headers: {
            'Content-Type': 'application/json',
          },
          isJson: true,
          responseType: 'blob',
        }
      },
    }),
    uploadUserLogo: builder.mutation<void, { userId?: number; name: string; file: any }>({
      query: ({ userId, name, file }) => {
        return {
          url: `file`,
          method: 'POST',
          data: { userId, name, file },
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      },
    }),
    changeUserLogo: builder.mutation<void, { userId?: number; name: string; file: any; imageId: number }>({
      query: ({ userId, name, file, imageId }) => {
        return {
          url: `file/${imageId}`,
          method: 'PUT',
          data: { userId, name, file },
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      },
    }),
    deleteUserLogo: builder.mutation<void, {}>({
      query: ({ }) => {
        return {
          url: `userinfos/logo`,
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      },
      invalidatesTags: ['UserInfo'],
    }),

    createProjectTrace: builder.mutation<any, { env?: number, project: any }>({
      query: ({ env, project }) => {
        return {
          url: `projectTrace/${env}`,
          method: 'POST',
          data: project,
          headers: {
            'Content-Type': 'application/json',
          },
          isJson: true,
        }
      },
    }),

    updateProjectTrace: builder.mutation<any, { traceId?: any, project: any }>({
      query: ({ traceId, project }) => {
        return {
          url: `projectTrace/${traceId}`,
          method: 'PATCH',
          data: project,
          headers: {
            'Content-Type': 'application/json',
          },
          isJson: true,
        }
      },
    }),
  }),
})

export const {
  useGetTranslationsQuery,
  useGetTutorialsQuery,
  useGetFAQQuery,
  useGetVersionsQuery,
  useGetMaintenanceQuery,
  useGetInfosQuery,
  useGetUserInfoQuery,
  useLazyGetUserInfoQuery,
  useUpdateUserInfoMutation,
  useUpdateSatisfactionMutation,
  useGetClientsQuery,
  ////////
  useCreateClientMutation,
  useUpdateClientMutation,
  useDeleteClientMutation,
  ///////
  useGetProjectsListQuery,
  useUpdateDublicateProjectMutation,
  useLazyLoadProjectQuery,
  useCreateProjectMutation,
  useUpdateProjectMutation,
  useDeleteProjectMutation,
  useLazyGetDepartmentsQuery,
  useLazyGetStationsQuery,
  useGetTbaseQuery,
  useLazyGetTbaseQuery,
  useGetLossMutation,
  useGetFlowTemperatureMutation,
  //useGetResultsQuery,
  useLazyGetResultsQuery,
  useLazyGetAccessoriesQuery,
  //useGetDocumentsQuery,
  useLazyGetDocumentsQuery,
  useUploadUserLogoMutation,
  useChangeUserLogoMutation,
  useDeleteUserLogoMutation,
  useLazyGetVATQuery,
  useGetHeatingSystemsQuery,
  useGenerateXlsxMutation,
  useGeneratePdfMutation,
  useGetParamentersQuery,
  useLazyGetParamentersQuery,
  //
  useCreateProjectTraceMutation,
  useUpdateProjectTraceMutation,
} = rtkApi

export default rtkApi
